import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { KioskGlobalSettings } from '@core/models/kiosk-global-settings.model';
import { loadKioskGlobalSettings } from './kiosk-global-settings.action';
import {
  selectKioskGlobalSettings,
  selectProductCardChoice,
  selectProductCardColSpan,
} from './kiosk-global-settings.selector';

@Injectable({
  providedIn: 'root',
})
export class KioskGlobalSettingsService {
  private readonly store = inject(Store);

  public readonly productCardChoice = this.store.selectSignal(selectProductCardChoice);
  public readonly productCardColSpan = this.store.selectSignal(selectProductCardColSpan);
  public readonly settings = this.store.selectSignal(selectKioskGlobalSettings);

  // Actions
  public loadSettings(settings: Partial<KioskGlobalSettings> | undefined): void {
    this.store.dispatch(loadKioskGlobalSettings({ settings }));
  }
}
